<style>
    @keyframes animatePulse {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
    .c-skeleton {
        height: 250px;
        background-color: var(--neutral-300);
        width: 1000px;
        animation-name: animatePulse;
        animation-duration: 3s;
        animation-iteration-count: infinite;
    }
</style>

<div class="c-skeleton" />
